module.exports = __webpack_public_path__ + "static/img/sig-logo.489fec1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sig-logo.png
// module id = 41IO
// module chunks = 1